import { normalizeUserLevel } from '@/lib/feature-permissions';

export const getUseChatLimit = (level?: unknown, remaining_days?: number, limit?: unknown) => {
  if (typeof limit === 'number' && Number.isFinite(limit) && limit >= 0) {
    return Math.floor(limit);
  }

  switch (normalizeUserLevel(level)) {
    case 'L1':
      if (typeof remaining_days !== 'number') {
        return 3;
      }
      if (remaining_days <= 0) {
        return 3;
      }
      return 10;
    case 'L2':
      return 50;
    case 'L3':
      // 9999 代表无限次使用
      return 9999;
    // 游客默认 3 次调用
    case 'L0':
      return 3;
    default:
      return 3;
  }
};
